import React from "react";
import { useSidebarStore } from "../store/sidebarStore";
import { showInfoToast } from "../toast/toast-service";
import { FormattedMessage } from "react-intl";

export const usePleaseLoginInfo = () => {
  const { setLoginSidebarOpen: setIsLoginSidebarOpen } = useSidebarStore();

  const openPleaseLoginInfo = () => {
    showInfoToast(<FormattedMessage id="login.please-login" />);
    setIsLoginSidebarOpen(true);
  };

  const isLoggedIn = Boolean(localStorage.getItem("token"));

  return { openPleaseLoginInfo, isLoggedIn };
};
